import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function Questionnaire() {
  const { t } = useTranslation();
  const image001 = useDocImage('questionnaire-img', 'image001.png');
  const image002 = useDocImage('questionnaire-img', 'image002.png');
  const image003 = useDocImage('questionnaire-img', 'image003.png');
  const image004 = useDocImage('questionnaire-img', 'image004.png');
  const image005 = useDocImage('questionnaire-img', 'image005.png');
  const image006 = useDocImage('questionnaire-img', 'image006.png');
  const image007 = useDocImage('questionnaire-img', 'image007.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.questionnaire.title')}</h1>
              <p className='header-para'>{t('documentation.questionnaire.intro')}</p>
              <h5>{t('documentation.questionnaire.keyFeatures.title')}</h5>
              <p>{t('documentation.questionnaire.keyFeatures.pageCustomization')}</p>
              <p>{t('documentation.questionnaire.keyFeatures.reportSection')}</p>
              <p>{t('documentation.questionnaire.keyFeatures.stagesConfig')}</p>
              <p className='pb-30'>{t('documentation.questionnaire.keyFeatures.save')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.questionnaire.accessing.title')}
                </div>
                <div className="card-body">

                  <ul>
                    <li>{t('documentation.questionnaire.accessing.steps.step1')}
                      <img src={image001} alt={t('documentation.questionnaire.accessing.imageAlt1')} className='img-fluid pb-20 pt-20' />
                    </li>
                    <li>{t('documentation.questionnaire.accessing.steps.step2')} <br />
                      <img src={image002} alt={t('documentation.questionnaire.accessing.imageAlt2')} className='img-fluid pt-20 pb-20' />
                    </li>

                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.questionnaire.fields.title')}
                </div>
                <div className="card-body">
                 
                  <p><b>{t('documentation.questionnaire.fields.pageHeading.title')}</b></p>
                  <img src={image003} alt={t('documentation.questionnaire.fields.pageHeading.imageAlt')} className='img-fluid  pt-10 pb-20' />
                  <ul>
                    <li>{t('documentation.questionnaire.fields.pageHeading.desc1')}</li>
                    <li>{t('documentation.questionnaire.fields.pageHeading.desc2')}</li>
                  </ul>

                  <p><b>{t('documentation.questionnaire.fields.buttonConfig.title')}</b></p>
                  <img src={image004} alt={t('documentation.questionnaire.fields.buttonConfig.imageAlt')} className='img-fluid pt-10 pb-20' />
                  <ul>
                    <li>{t('documentation.questionnaire.fields.buttonConfig.next')}</li>
                    <li>{t('documentation.questionnaire.fields.buttonConfig.submit')}</li>
                    <li>{t('documentation.questionnaire.fields.buttonConfig.back')}</li>
                  </ul>

                  <p><b>{t('documentation.questionnaire.fields.reportSection.title')}</b></p>
                  <img src={image005} alt={t('documentation.questionnaire.fields.reportSection.imageAlt')} className='img-fluid pt-10 pb-20' />
                  <ul>
                    <li>{t('documentation.questionnaire.fields.reportSection.reportPageHeading')}</li>
                    <li>{t('documentation.questionnaire.fields.reportSection.reportHeading')}</li>
                    <li>{t('documentation.questionnaire.fields.reportSection.stageField')}</li>
                  </ul>

                  <p><b>{t('documentation.questionnaire.fields.stages.title')}</b></p>
                  <img src={image006} alt={t('documentation.questionnaire.fields.stages.imageAlt')} className='img-fluid  pt-10 pb-20' />
                  <ul>
                    <li>{t('documentation.questionnaire.fields.stages.desc1')}</li>
                    <li>{t('documentation.questionnaire.fields.stages.desc2')}</li>
                  </ul>


                  <p><b>{t('documentation.questionnaire.fields.saveButton.title')}</b></p>
                  <img src={image007} alt={t('documentation.questionnaire.fields.saveButton.imageAlt')} className=' pb-10' />
                  <ul>
                    <li>{t('documentation.questionnaire.fields.saveButton.desc1')}</li>
                    <li>{t('documentation.questionnaire.fields.saveButton.desc2')}</li>
                  </ul>

                  <p>{t('documentation.questionnaire.fields.conclusion')}</p>
                </div>
              </div>



            </div>
          </div>

        </div>
      </div>
    </>
  )
}
